import * as Common from "../../commons/common"

export class Examinee {
  id: number
  seqNo: number
  student_no: number
  student_code: number
  cram_code: number
  student_name: string
  is_exists_result_image: boolean = false
  score: number
  saitenCompletedFieldCount: number
  checked: boolean = false
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  fieldActivities: FieldActivity[] = new Array<FieldActivity>()
  base64ScanImages: string[] = new Array<string>();
  base64ResultImages: string[] = new Array<string>();

  constructor(examinee: any, sheetActivities: SheetActivity[], fieldActivities: FieldActivity[], exists_result_image_student_nos: number[], no: number){
    this.id = examinee.id;
    this.seqNo = no;
    this.student_no = examinee.student_no;
    this.student_code = examinee.student_code;
    this.student_name = examinee.student_name;
    this.cram_code = examinee.cram_code;
    this.is_exists_result_image = exists_result_image_student_nos.filter(x => x == this.student_no).length > 0;
    this.sheetActivities = sheetActivities.filter(x => x.student_id == this.student_no);
    this.sheetActivities.forEach(x => {
      this.fieldActivities = this.fieldActivities.concat(fieldActivities.filter(y => y.sheet_activity_id == x.id));
    });
    this.saitenCompletedFieldCount = this.fieldActivities.filter(x => x.saiten_completed).length;
    this.score = Common.sumArray(this.fieldActivities.map(x => x.score == null ? 0 : x.score));
  }
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number
  correct_state: number
  saiten_completed: boolean
  
  constructor(fieldActiviby: any){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    this.score = fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.saiten_completed = fieldActiviby.saiten_completed;
  }
}

export class Sheet {
  base_sheet_id: number
  grade: number
  name: string
  room_name: string
  class_name: string
  curriculum_id: number
  level: string
  allot: number
  page_count: number
  capture_date: string

  constructor(sheet: any){
    this.base_sheet_id = sheet.base_sheet_id;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.class_name = sheet.class_name;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.level = sheet.level;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.capture_date = sheet.capture_date;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  FieldActivities: FieldActivity[] = new Array<FieldActivity>()
  isSaitenCompleted: boolean
  saitenCompletedCount: number
  pendingCount: number

  constructor(sheetField: any, fieldActivities: FieldActivity[]){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.allotCache = sheetField.allot;
    this.FieldActivities = fieldActivities.filter(x => x.sheet_field_id == this.id);
    const totalScore: number = Common.sumArray(this.FieldActivities.map(x => x.score == null ? 0 : x.score));
    this.scoreAverage = Number((totalScore / this.FieldActivities.length).toFixed(1));
    this.scoreRate = Math.round(totalScore / (this.allot * this.FieldActivities.length) * 100);
    this.isSaitenCompleted = this.FieldActivities.filter(x => !x.saiten_completed).length == 0;
    this.saitenCompletedCount = this.FieldActivities.filter(x => x.saiten_completed).length;
    this.pendingCount = this.FieldActivities.filter(x => x.correct_state == Common.CorrectStateEnum.Pending).length;
  }
}

export class ScoreOption {
  value: number
  text: string

  constructor(value: number, text: string){
    this.value = value;
    this.text = text;
  }
}